'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _interopRequireDefault = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _React = require('react');

var _React2 = _interopRequireDefault(_React);

var _classNames = require('classnames');

var _classNames2 = _interopRequireDefault(_classNames);

var PageItem = _React2['default'].createClass({
  displayName: 'PageItem',

  propTypes: {
    href: _React2['default'].PropTypes.string,
    target: _React2['default'].PropTypes.string,
    title: _React2['default'].PropTypes.string,
    disabled: _React2['default'].PropTypes.bool,
    previous: _React2['default'].PropTypes.bool,
    next: _React2['default'].PropTypes.bool,
    onSelect: _React2['default'].PropTypes.func,
    eventKey: _React2['default'].PropTypes.any
  },

  getDefaultProps: function getDefaultProps() {
    return {
      href: '#'
    };
  },

  render: function render() {
    var classes = {
      disabled: this.props.disabled,
      previous: this.props.previous,
      next: this.props.next
    };

    return _React2['default'].createElement(
      'li',
      _extends({}, this.props, {
        className: _classNames2['default'](this.props.className, classes) }),
      _React2['default'].createElement(
        'a',
        {
          href: this.props.href,
          title: this.props.title,
          target: this.props.target,
          onClick: this.handleSelect,
          ref: 'anchor' },
        this.props.children
      )
    );
  },

  handleSelect: function handleSelect(e) {
    if (this.props.onSelect) {
      e.preventDefault();

      if (!this.props.disabled) {
        this.props.onSelect(this.props.eventKey, this.props.href, this.props.target);
      }
    }
  }
});

exports['default'] = PageItem;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-bootstrap/lib/PageItem.js
 ** module id = 235
 ** module chunks = 0
 **/